<template>
  <div class="box box_v" style="height: 100%">
    <div class="mini-header-wrapper">
      <div class="left">
        <div class="iconfont icon-fanhui2" style="font-size:35px" @click="goback"></div>
      </div>
      <div class="mini-header">功能模块设置</div>
      <div class="newvote">
        <Button class="btn-dc" type="primary" @click="setModule">发布</Button>
      </div>
    </div>
    <div class="item-wrapper box box_f1">
      <Card style="width: 100%;margin-right: 20px;margin-bottom: 20px">
        <div class="card-content box">
          <div class="box_f1">
            <div class="i-title">
              <label class="i-label">标题</label>
              <Input class="i-input" v-model="title" width="360px" placeholder="请输入标题" />
            </div>
            <div class="i-title">
              <label class="i-label">副标题</label>
              <Input class="i-input" v-model="remark" width="360px" placeholder="请输入副标题" />
            </div>
            <div class="i-title1">
              <label class="i-label" style="margin-top: 0">图标</label>
              <div
                class="i-input"
                @mouseover="mouseOver"
                @mouseleave="mouseLeave"
                style="max-width: 85px"
              >
                <img :src="src" alt />
                <div class="icon" :style="display" @click="checkPic">
                  <i class="iconfont icon-bianji1"></i>
                </div>
              </div>
            </div>
            <div class="i-title">
              <label class="i-label">关联模块</label>
              <Select v-model="selVal" style="width:360px" @on-change="selChange">
                <Option
                  v-for="item in moduleList"
                  :value="item.mId"
                  :key="item.mId"

                >{{ item.name }}</Option>
              </Select>
            </div>
            <div class="i-title">
              <label class="i-label">是否展示</label>
              <RadioGroup v-model="service" class="i-input" style="mcolor: #999">
                <Radio label="是"></Radio>
                <Radio label="否"></Radio>
              </RadioGroup>
            </div>
          </div>
          <div class="box_f1 box example">
            <div class="box" style="margin-right: 20px">示例</div>
            <div class="box_f1 eg-img">
              <div class="img">
                <img class="box" :src="src" alt />
              </div>
              <p>{{title}}</p>
            </div>
          </div>
        </div>
      </Card>
    </div>
    <Modal v-model="showDel" title="选择图标" width="522" @on-ok="ok">
      <div class="box" style="flex-wrap: wrap">
        <div class="icon-check box_f1" v-for="(item, index) in iconList" :key="index" @click="checkIcon(index)">
          <img :src="item.url" alt />
          <div class="gou" v-if="item.isCheck">
            <i class="iconfont icon-duigou"></i>
          </div>
        </div>
        <upload-img
          :imgArr="imgArr"
          :imgNumber="imgNumber"
          :imgHeight="60"
          :imgWidth="50"
          @saveImg="saveImg"
          :isActive="isActive"
        >
          <div class="add-icon">
            <i class="iconfont icon-tianjiajiahaowubiankuang" style="font-size: 36px"></i>
          </div>
        </upload-img>
      </div>
      <Spin fix v-if="iconLoading"></Spin>
    </Modal>
    <Spin fix size="large" v-if="loading"></Spin>
  </div>
</template>

<script>
import uploadImg from "../../components/uplImgAct";
var that;
export default {
  data() {
    return {
      title: "",
      hold: "标题",
      service: "是",
      remark: "",
      display: "display: none",
      moduleList: [],
      iconList: [],
      src: "",
      selVal: "",
      loading: false,
      showDel: false,
      imgNumber: 1,
      imgArr: [],
      isActive: false,
      iconLoading: false,
      iconCheck: {},
      moduleSel: {}
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    mouseOver() {
      this.display = "";
    },
    mouseLeave() {
      this.display = "display: none";
    },
    getDetail(id) {
      var url = this.urlobj.getModelDetail;
      var data = { id };
      return new Promise((resolve, reject) => {
        this.$get(url, data)
          .then(res => {
            if (res.isSucceed) {
              resolve(res.rows[0]);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getIconList(id) {
      var url = this.urlobj.getModelIcon;
      var data = { id };
      return new Promise(resolve => {
        this.$post(url, data)
          .then(res => {
            if (res.isSucceed) {
              resolve(res);
            }
          })
          .catch(e => {
            console.log(e);
          });
      });
    },
    getModule(mId) {
      var url = this.urlobj.getConnectModel;
      var data = { mId };
      return new Promise(resolve => {
        this.$post(url, data)
          .then(res => {
            if (res.isSucceed) {
              resolve(res);
            }
          })
          .catch(e => {
            console.log(e);
          });
      });
    },
    getModuleDetail(id, mId) {
      this.loading = true;
      var getDetail = this.getDetail(id);
      var getIconList = this.getIconList(id);
      var getModule = this.getModule(mId);
      Promise.all([getDetail, getIconList, getModule]).then(res => {
        this.title = res[0].moduleName;
        this.remark = res[0].subTitle ? res[0].subTitle : "";
        this.src = res[0].iconUrl;
        this.service = res[0].isShow == 1 ? "是" : "否";
        this.selVal = res[0].moduleId;
        var iconList = res[1].rows.map(item => {
          return {
            iconId: item.id,
            url: item.iconUrl,
            isCheck: item.iconUrl == res[0].iconUrl,
          };
        });
        var moduleList = res[2].rows.map(item => {
          return {
            mId: item.id,
            name: item.moduleName,
            value: item.moduleValue
          };
        });
        this.iconList = iconList;
        this.moduleList = moduleList;
        this.loading = false;
      });
    },
    selChange(value) {
      console.log(value);
      for(let i = 0 ; i < this.moduleList.length ; i++){
        if(this.moduleList[i].mId == value) {
          console.log('1111')
          this.moduleSel = this.moduleList[i]
        }
      }
      console.log(this.moduleSel)
    },
    checkPic() {
      this.showDel = true;
    },
    checkIcon(index) {
      for(let i = 0; i < this.iconList.length; i++) {
        this.iconList[i].isCheck = false
        if(i == index) {
          this.iconList[i].isCheck = true
          this.iconCheck = this.iconList[i]
        }
      }
    },
    ok() {
      this.src = this.iconCheck.url
    },
    saveImg(data) {
      this.iconLoading = true
      var path = data.path;
      var url = this.urlobj.addIcon;
      var data = {
        iconUrl: path
      };
      this.$post(url, data).then(res => {
        if (res.isSucceed) {
          var getIconList = this.getIconList(this.$route.query.id);
          Promise.all([getIconList]).then(res => {
            var iconList = res[0].rows.map(item => {
              return {
                iconId: item.id,
                url: item.iconUrl,
                isCheck: item.id == res[0].moduleId ? true : false
              };
            });
            this.iconList = iconList
            this.iconLoading = false
          });
        }
      });
    },
    setModule() {
      var data = {
        id: this.$route.query.id,
        moduleId: this.moduleSel.mId,
        moduleName: this.title,
        appType: this.$store.state.apptype,
        subTitle: this.remark,
        isShow: this.service == '是' ? 1 : 0,
        iconUrl: this.src
      }
      this.loading = true
      this.$post(this.urlobj.setModule, data).then(res => {
        if(res.isSucceed == false){
          this.$Message.warning(res.message)
          this.loading = false
          return
        }
        this.$Message.success('操作成功')
        this.getModuleDetail(this.$route.query.id, this.$route.query.moduleId)
      })
    },
  },
  mounted() {
    this.getModuleDetail(this.$route.query.id, this.$route.query.moduleId);
    console.log(this.$route.query.moduleId)
  },
  created() {
    that = this;
  },
  components: {
    uploadImg
  }
};
</script>

<style lang="less" scoped>
.left {
  position: absolute;
  left: 20px;
  font-size: 22px;
}
.mini-header-wrapper {
  display: flex;
  /*height: 30px;*/
  line-height: 30px;
  padding: 30px 0;
  justify-content: center;
  position: relative;
}
.mini-header {
  font-size: 25px;
  text-align: center;
}
.item-wrapper {
  padding-left: 20px;
}
.newvote {
  position: absolute;
  right: 20px;
  button {
    width: 80px;
    height: 28px;
    line-height: 13px;
  }
  .btn-dc {
    background-color: #ff7c43;
    border-color: #ff7c43;
  }
}
.i-label {
  min-width: 4em;
  white-space: nowrap;
  text-align: right;
  font-size: 14px;
  color: #666;
  margin: 15px 10px 15px 0;
}
.i-input {
  flex: 1;
  position: relative;
  img {
    width: 85px;
    height: 85px;
    border-radius: 50%;
  }
  .icon {
    width: 85px;
    height: 85px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.3);
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    .iconfont {
      font-size: 40px;
      line-height: 85px;
      color: #fff;
    }
  }
}
.i-title {
  display: flex;
  align-items: center;
}
.i-title1 {
  display: flex;
  //   align-items: center;
}
.eg-img {
  height: 118px;
  max-width: 98px;
  border: 1px solid #dedede;
  border-radius: 2px;
  text-align: left;
  .img {
    margin: auto;
    width: 62px;
    height: 62px;
    margin-top: 18px;
    img {
      width: 62px;
      height: 62px;
      border-radius: 50%;
    }
  }
  p {
    margin-top: 10px;
    text-align: center;
  }
}
/deep/ .ivu-input {
  max-width: 360px;
}
.example {
  margin-left: -30%;
  margin-top: 5px;
}
.icon-check {
  min-width: 98px;
  max-width: 98px;
  position: relative;
  margin-bottom: 20px;
  // padding-bottom: 20px;
  img {
    width: 73px;
    height: 73px;
    border-radius: 50%;
  }
  .gou {
    position: absolute;
    width: 73px;
    height: 73px;
    color: #fff;
    background: rgba(0, 0, 0, 0.3);
    top: 0;
    left: 0;
    border-radius: 50%;
    text-align: center;
    .iconfont {
      font-size: 36px;
      line-height: 73px;
      // text-align: center;
    }
  }
}
.add-icon {
  background: #ccc;
  border-radius: 50%;
  width: 73px;
  height: 73px;
  line-height: 80px;
  text-align: center;
}
</style>
